import React, { useState } from "react";
import { Button, Input } from "@petsapp/chameleon";
import useAuth from "@petsapp/use-auth";
import { FormType } from "./auth-controller";
import { useTranslation } from "../../utils/i18n";

interface ResetPasswordFormProps {
  setFormType: React.Dispatch<React.SetStateAction<FormType>>;
}

export const ResetPasswordForm: React.FunctionComponent<ResetPasswordFormProps> = ({
  setFormType,
}) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>();
  const [emailError, setEmailError] = useState<string>();

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setEmailError(email ? undefined : "Please provide an email");

    if (!email) {
      return;
    }

    setLoading(true);
    try {
      await auth.resetPassword({
        email,
      });
      setFormType("reset-successful");
    } catch (error) {
      setEmailError(
        t("Something went wrong. Please check your email and try again."),
      );
      setLoading(false);
    }
  }

  return (
    <form onSubmit={submit}>
      <Input
        id="email"
        error={emailError}
        onChange={(e) => setEmail(e.currentTarget.value)}
        label={t("Email")}
        type="email"
      />
      <Button
        type="submit"
        variant="primary"
        state={loading ? "loading" : undefined}
      >
        {t("Reset password")}
      </Button>
    </form>
  );
};
